import { Action } from '@ngrx/store';

import { Glossary } from 'src/app/shared/models/glossary.model';
import { Translation } from 'src/app/shared/models/translation.model';
import { RestoreUserFailure, RestoreUserSuccess } from 'src/app/utenti/store';
import { Note } from 'src/app/shared/models/note.model';
import { Observable } from 'rxjs';
import { Attachment } from 'src/app/shared/models/attachment.model';
import { FilterDataGlossResponse } from '../glossari.service';
import { orderByModel } from 'src/app/shared/models/filter-data/order-by.model';
import { SingleFilter } from 'src/app/shared/models/filter-data/single-filter.model';
import { OperatorFilter } from 'src/app/shared/models/filter-data/operator-filter.model';

/**Enumerazione che indica le possibili tabelle glossari interessate dalle azioni */
export enum tabellaGlossari {
    main,
    mainFilterSort,
    modal
}

/**Descrizione per il tipo StartGetListGlos */
export const START_GET_LIST_GLOS = '[GLOS] Inizio recupero lista delle voci di glossario';
/**Descrizione per il tipo GetListGlosSuccess */
export const GET_LIST_GLOS_SUCCESS = '[GLOS] Recupero lista delle voci di glossario avvenuto con successo';
/**Descrizione per il tipo GetListGlosFailure */
export const GET_LIST_GLOS_FAILURE = '[GLOS] Mancato recupero lista delle voci di glossario';

/**Descrizione per il tipo CleanOnDestroy */
export const CLEAN_ON_DESTROY = '[GLOS] Svuotamento dello state in distruzione';

/**Descrizione per il tipo SortGlos */
export const APPLY_SORT_GLOS = '[GLOS] Aggiorna elenco degli ordinamenti';

/**Descrizione per il tipo SelectGlossary */
export const SELECT_GLOSSARY = '[GLOS] Selezione di una voce di glossario';

/**Descrizione per il tipo StartUpdateGlossary */
export const START_UPDATE_GLOSSARY = '[GLOS] Inizio modifica di un campo di una voce glossario';
/**Descrizione per il tipo UpdateGlossarySuccess */
export const UPDATE_GLOSSARY_SUCCESS = '[GLOS] Azione di modifica di una voce glossario avvenuta con successo';
/**Descrizione per il tipo UpdateGlossaryFailure */
export const UPDATE_GLOSSARY_FAILURE = '[GLOS] Mancato aggiornamento della voce di glossario';

/**Descrizione per il tipo StartUpdateMultipleFields */
export const START_UPDATE_MULTIPLE_FIELDS = '[GLOS] Azione di inizio aggiornamento campi multipli di glossario';
/**Descrizione per il tipo UpdateMultipleFieldsSuccess */
export const UPDATE_MULTIPLE_FIELDS_SUCCESS = '[GLOS] Aggiornamento campi multipli di glossario avvenuto con successo';
/**Descrizione per il tipo UpdateMultipleFieldsFailure */
export const UPDATE_MULTIPLE_FIELDS_FAILURE = '[GLOS] Mancato aggiornamento campi multipli di glossario';

/**Descrizione per il tipo StartGetTranslations */
export const START_GET_TRANSLATIONS = '[GLOS] Inizio recupero dei riferimenti alla voce di glossario selezionata';
/**Descrizione per il tipo GetTranslationsSuccess */
export const GET_TRANSLATIONS_SUCCESS = '[GLOS] Azione di recupero dei riferimenti avvenuto con successo';
/**Descrizione per il tipo GetTranslationsFailure */
export const GET_TRANSLATIONS_FAILURE = '[GLOS] Mancato recupero dei riferimenti';

/**Descrizione per il tipo StartGetSeeAlso */
export const START_GET_SEEALSO = '[GLOS] Inizio recupero dei vedi anche della voce di glossario selezionata';
/**Descrizione per il tipo GetSeeAlsoSuccess */
export const GET_SEEALSO_SUCCESS = '[GLOS] Recupero dei vedi anche avvenuto con successo';
/**Descrizione per il tipo GetSeeAlsoFailure */
export const GET_SEEALSO_FAILURE = '[GLOS] Mancato recupero dei vedi anche';

/**Descrizione per il tipo ApplyFilters */
export const APPLY_FILTERS = '[GLOS] Applicazione di filtri alla tabella delle voci glossario';

/**Descrizione per il tipo IsLoadingTabella */
export const IS_LOADING_TABELLA = '[GLOS] Visualizza o meno lo spinner di loading della tabella voci glossario';

/**Descrizione per il tipo SetRowInterval */
export const SET_ROW_INTERVAL = '[GLOS] Imposto intervallo di righe da recuperare';

/**Descrizione per il tipo DestroyModalCercaGlossario */
export const DESTROY_MODAL_CERCA_GLOSSARIO = '[GLOS] Cancello i dati del modale in chiusura dello stesso';

/**Descrizione per il tipo SetSecondarySelections */
export const SET_SECONDARY_SELECTIONS = '[GLOS] Memorizzo le voci di glossario secondarie selezionate';

/**Descrizione per il tipo StartAddSeeAlso */
export const START_ADD_SEEALSO = '[GLOS] Azione di inizio aggiunta nuova voce see also';
/**Descrizione per il tipo AddSeeAlsoSuccess */
export const ADD_SEEALSO_SUCCESS = '[GLOS] Azione di avvenuta aggiunta nuove voce see also';
/**Descrizione per il tipo AddSeeAlsoFailure */
export const ADD_SEEALSO_FAILURE = '[GLOS] Azione di mancata aggiunta nuova voce see also';

/**Descrizione per il tipo StartRemoveSeeAlso */
export const START_REMOVE_SEEALSO = '[GLOS] Azione di inizio rimozione voce see also';
/**Descrizione per il tipo RemoveSeeAlsoSuccess */
export const REMOVE_SEEALSO_SUCCESS = '[GLOS] Azione di avvenuta rimozione voce see also';
/**Descrizione per il tipo RemoveSeeAlsoFailure */
export const REMOVE_SEEALSO_FAILURE = '[GLOS] Azione di mancata rimozione voce see also';

/**Descrizione per il tipo StartAddNewGlossary */
export const START_ADD_NEW_GLOSSARY = '[GLOS] Azione di inizio aggiunta nuova voce di glossario';
/**Descrizione per il tipo AddNewGlossarySuccess */
export const ADD_NEW_GLOSSARY_SUCCESS = '[GLOS] Azione di avvenuta aggiunta nuova voce di glossario';
/**Descrizione per il tipo AddNewGlossaryFailure */
export const ADD_NEW_GLOSSARY_FAILURE = '[GLOS] Azione di mancata aggiunta nuova voce di glossario';

/**Descrizione per il tipo StartRemoveGlossary */
export const START_REMOVE_GLOSSARY = '[GLOS] Azione di inizio rimozione voce di glossario';
/**Descrizione per il tipo RemoveGlossarySuccess */
export const REMOVE_GLOSSARY_SUCCESS = '[GLOS] Azione di avvenuta rimozione voce di glossario';
/**Descrizione per il tipo RemoveGlossaryFailure */
export const REMOVE_GLOSSARY_FAILURE = '[GLOS] Azione di mancata rimozione voce di glossario';

/**Descrizione per il tipo ChangeDisplayAdd */
export const CHANGE_DISPLAY_ADD = "[GLOS] Azione di visualizzazione o meno della colonna di aggiunta utente";

/**Descrizione per il tipo StartRestoreGlos */
export const START_RESTORE_GLOS = '[GLOS] Azione di inizio ripristino voce di glossario';
/**Descrizione per il tipo RestoreGlosSuccess */
export const RESTORE_GLOS_SUCCESS = '[GLOS] Ripristino voce di glossario avvenuto';
/**Descrizione per il tipo RestoreGlosFailure */
export const RESTORE_GLOS_FAILURE = '[GLOS] Mancato ripristino voce di glossario';

/**Descrizione per il tipo StartUpdateReferenceTransl */
export const START_UPDATE_REFERENCE_TRANSL = '[GLOS] Azione di inizio aggiornamento traduzione riferimento';
/**Descrizione per il tipo UpdateReferenceTranslSuccess */
export const UPDATE_REFERENCE_TRANSL_SUCCESS = '[GLOS] Aggiornamento traduzione riferimento riuscito';
/**Descrizione per il tipo UpdateReferenceTranslFailure */
export const UPDATE_REFERENCE_TRANSL_FAILURE = '[GLOS] Mancato aggiornamento traduzione riferimento';

/**Descrizione per il tipo StartDissociateGlosFromGlosSect */
export const START_DISSOCIATE_GLOS_FROM_GLOS_SECT = '[GLOS] Azione di inizio dissociazione glossario da stringa di traduzione in sezione glossari';
/**Descrizione per il tipo DissociateGlosFromGlosSectSuccess */
export const DISSOCIATE_GLOS_FROM_GLOS_SECT_SUCCESS = '[GLOS] Dissociazione glossario da stringa di traduzione in sezione glossari avvenuta con successo';
/**Descrizione per il tipo DissociateGlosFromGlosSectFailure */
export const DISSOCIATE_GLOS_FROM_GLOS_SECT_FAILURE = '[GLOS] Mancata dissociazione glossario da una stringa di traduzione in sezione glossari';

/**Descrizione per il tipo StartDissociateAllReferences */
export const START_DISSOCIATE_ALL_REFERENCES = '[GLOS] Azione di inizio rimozione riferimenti a un glossario';
/**Descrizione per il tipo DissociateAllReferencesSuccess */
export const DISSOCIATE_ALL_REFERENCES_SUCCESS = '[GLOS] Rimozione dei riferimenti a un glossario avvenuta con successo';
/**Descrizione per il tipo DissociateAllReferencesFailure */
export const DISSOCIATE_ALL_REFERENCES_FAILURE = '[GLOS] Mancata rimozione dei riferimenti a un glossario';

/**Descrizione per il tipo StartGetReferenceNotes */
export const START_GET_REFERENCE_NOTES = '[GLOS] Azione di inizio recupero note di un riferimento';
/**Descrizione per il tipo GetReferenceNotesSuccess */
export const GET_REFERENCE_NOTES_SUCCESS = '[GLOS] Recupero note di un riferimento avvenuto con successo';
/**Descrizione per il tipo GetReferenceNotesFailure */
export const GET_REFERENCE_NOTES_FAILURE = '[GLOS] Mancato recupero note di un riferimento';

/**Descrizione per il tipo StartGetReferenceGlossaries */
export const START_GET_REFERENCE_GLOSSARIES = '[GLOS] Azione di inizio recupero glossari di un riferimento';
/**Descrizione per il tipo GetReferenceGlossariesSuccess */
export const GET_REFERENCE_GLOSSARIES_SUCCESS = '[GLOS] Recupero glossari di un riferimento avvenuto con successo';
/**Descrizione per il tipo GetReferenceGlossariesFailure */
export const GET_REFERENCE_GLOSSARIES_FAILURE = '[GLOS] Mancato recupero glossari di un riferimento';

/**Descrizione per il tipo CleanReferenceDetails */
export const CLEAN_REFERENCE_DETAILS = '[GLOS] Azione che svuota le note e i glossari di dettaglio a un riferimento';

/**Descrizione per il tipo StartGetGlosHistory */
export const START_GET_GLOS_HISTORY = '[GLOS] Azione di inizio recupero storico di una voce di glossario';
/**Descrizione per il tipo GetGlosHistorySuccess */
export const GET_GLOS_HISTORY_SUCCESS = '[GLOS] Recupero storico di una voce di glossario avvenuto con successo';
/**Descrizione per il tipo GetGlosHistoryFailure */
export const GET_GLOS_HISTORY_FAILURE = '[GLOS] Mancato recupero storico di una voce di glossario';

/**Descrizione per il tipo StartAssociateMultipleGlos */
export const START_ASSOCIATE_MULTIPLE_GLOS = '[GLOS] Azione di inizio associazione a un glossario dei riferimenti di altri glossari';
/**Descrizione per il tipo AssociateMultipleGlosSuccess */
export const ASSOCIATE_MULTIPLE_GLOS_SUCCESS = '[GLOS] Associazione a un glossario dei riferimenti di altri glossari avvenuta con successo';
/**Descrizione per il tipo AssociateMultipleGlosFailure */
export const ASSOCIATE_MULTIPLE_GLOS_FAILURE = '[GLOS] Mancata associazione a un glossario dei riferimenti di altri glossari';

/**Descrizione per il tipo DisplayGlosHistory */
export const DISPLAY_GLOS_HISTORY = '[GLOS] Azione che gestisce la visibilità dello storico';

/**Descrizione per il tipo StartGetSeeAlsoIncomeTranslations */
export const START_GET_SEEALSO_INCOME_TRANSLATIONS = '[GLOS] Azione di inizio recupero delle traduzioni dove occorrono i glossari che riferiscono la voce come vedi anche';
/**Descrizione per il tipo GetSeeAlsoIncomeTranslationsSuccess */
export const GET_SEEALSO_INCOME_TRANSLATIONS_SUCCESS = '[GLOS] Recupero delle traduzioni dove occorrono i glossari che riferiscono la voce come vedi anche avvenuto con success';
/**Descrizione per il tipo GetSeeAlsoIncomeTranslationsFailure */
export const GET_SEEALSO_INCOME_TRANSLATIONS_FAILURE = '[GLOS] Mancato recupero delle traduzioni dove occorrono i glossari che riferiscono la voce come vedi anche';

/**Descrizione per il tipo StartGetSeeAlsoIncome */
export const START_GET_SEEALSO_INCOME = '[GLOS] Azione di inizio recupero delle voci di glossario che puntano come see also';
/**Descrizione per il tipo GetSeeAlsoIncomeSuccess */
export const GET_SEEALSO_INCOME_SUCCESS = '[GLOS] Recupero delle voci di glossario che puntano come see also avvenuto con successo';
/**Descrizione per il tipo GetSeeAlsoIncomeFailure */
export const GET_SEEALSO_INCOME_FAILURE = '[GLOS] Mancato recupero delle voci di glossario che puntano come see also';

/**Descrizione per il tipo StartGetGlossaryAttachment */
export const START_GET_GLOSSARY_ATTACHMENT = '[GLOS] Azione di inizio recupero allegato a un glossario';
/**Descrizione per il tipo GetGlossaryAttachmentSuccess */
export const GET_GLOSSARY_ATTACHMENT_SUCCESS = '[GLOS] Recupero allegato a un glossario avvenuto con successo';
/**Descrizione per il tipo GetGlossaryAttachmentFailure */
export const GET_GLOSSARY_ATTACHMENT_FAILURE = '[GLOS] Mancato recupero allegato a un glossario';

/**Azione di inizio recupero delle voci di glossario */
export class StartGetListGlos implements Action {
    readonly type = START_GET_LIST_GLOS;

    /**
     * Costruttore per l'azione StartGetListGlos
     * @param payload {tabellaGlossari} la tabella interessata dal recupero dati
     * @param reload {boolean} definisce se deve essere forzata una nuova query a BE
     */
    constructor(public payload: tabellaGlossari,
        public reload: boolean = false) { }
}

/**Azione di avvenuto recupero delle voci di glossario */
export class GetListGlosSuccess implements Action {
    readonly type = GET_LIST_GLOS_SUCCESS;

    /**
     * Costruttore per l'azione di avvenuto recupero delle voci di glossario
     * @param payload {object} sezione tabellaGlossari indica se siamo nella principale o nel modale, elenco ListGlossariResponse risposta da BE contiene elenco dei glossari, conteggio, ordinamento e filtri
     */
    constructor(public payload: { sezione: tabellaGlossari, elenco: FilterDataGlossResponse }) { }
}

/**Azione di mancato recupero delle voci di glossario */
export class GetListGlosFailure implements Action {
    readonly type = GET_LIST_GLOS_FAILURE;

    constructor(public payload: any) { }
}

/**Azione di pulizia dello stato a livello dei glossari */
export class CleanOnDestroy implements Action {
    readonly type = CLEAN_ON_DESTROY;
}

/**Azione inserimento degli ordinamenti da applicare all'elenco glossari */
export class ApplySortGlos implements Action {
    readonly type = APPLY_SORT_GLOS;

    /**
     * Costruttore per l'azione ApplySortGlos
     * @param payload {orderByModel[]} elenco di istruzioni di ordinamento definite secondo l'interfaccia
     */
    constructor(public payload: orderByModel[]) { }
}

/**Azione di selezione di una voce di glossario */
export class SelectGlossary implements Action {
    readonly type = SELECT_GLOSSARY;

    /**
     * Costruttore per l'azione SelectGlossary
     * @param payload {Glossary} la voce di glossario selezionata
     */
    constructor(public payload: Glossary) { }
}

/**Azione di inizio aggiornamento di una voce di glossario */
export class StartUpdateGlossary implements Action {
    readonly type = START_UPDATE_GLOSSARY;

    /**
     * Costruttore per l'azione StartUpdateGlossary
     * @param payload {object} idGlos (number) id della voce di glossario modificata, nomeCampo (string) nome della proprietà del glossario modificata, newValue (any) nuovo valore della proprietà
     * @param isUndoRedoOperation {boolean} definisce se l'azione è lanciata nell'ambito di un'azione di undo
     */
    constructor(public payload: { idGlos: number, nomeCampo: string, newValue: any },
        public isUndoRedoOperation: boolean = false) { }
}

/**Azione di avvenuta modifica della voce di glossario */
export class UpdateGlossarySuccess implements Action {
    readonly type = UPDATE_GLOSSARY_SUCCESS;

    /**
     * Costruttore per l'azione UpdateGlossarySuccess
     * @param payload {Glossary} voce di glossario modificata
     * @param isUndoRedoOperation {boolean} definisce se l'azione è lanciata nell'ambito di un'azione di undo
     */
    constructor(public payload: { nuovoGlos: Glossary, campoMod: string },
        public isUndoRedoOperation: boolean = false) { }
}

/**Azione di mancata modifica della voce di glossario */
export class UpdateGlossaryFailure implements Action {
    readonly type = UPDATE_GLOSSARY_FAILURE;

    constructor(public payload: any) { }
}

/**Azione di inizio modifica di un glossario su più campi */
export class StartUpdateMultipleFields implements Action {
    readonly type = START_UPDATE_MULTIPLE_FIELDS;
    /**
     * Costruttore per l'azione StartUpdateMultipleFields
     * @param payload {object} idGlos (number) id della voce di glossario da modificare, modifiedProp (any) la/e proprietà modificata/e
     */
    constructor(public payload: { idGlos: number, modifiedProp: any }) { }
}
/**Azione di avvenuta modifica di un glossario su più campi */
export class UpdateMultipleFieldsSuccess implements Action {
    readonly type = UPDATE_MULTIPLE_FIELDS_SUCCESS;
    /**
     * Costruttore per l'azione UpdateMultipleFieldsSuccess
     * @param payload {Glossary} glossario modificato
     */
    constructor(public payload: Glossary) { }
}
/**Azione di mancata modifica di un glossario su più campi */
export class UpdateMultipleFieldsFailure implements Action {
    readonly type = UPDATE_REFERENCE_TRANSL_FAILURE;
}

/**Azione di inizio recupero dei riferimenti a una voce di glossario, che sono le traduzioni in cui compare */
export class StartGetTranslations implements Action {
    readonly type = START_GET_TRANSLATIONS;

    /**
     * Costruttore per l'azione StartGetTranslations
     * @param payload {number} id del glossario selezionato
     */
    constructor(public payload: number) { }
}

/**Azione di avvenuto recupero dei riferimenti alla voce di glossario selezionata */
export class GetTranslationsSuccess implements Action {
    readonly type = GET_TRANSLATIONS_SUCCESS;

    /**
     * Costruttore per l'azione di avvenuto recupero riferimenti
     * @param payload {Translation[]} elenco dei riferimenti
     */
    constructor(public payload: Translation[]) { }
}

/**Azione di mancato recupero dei riferimenti alla voce di glossario selezionata */
export class GetTranslationsFailure implements Action {
    readonly type = GET_TRANSLATIONS_FAILURE;

    constructor(public payload: any) { }
}

/**Azione di inizio recupero dei see also per la voce di glossario selezionata */
export class StartGetSeeAlso implements Action {
    readonly type = START_GET_SEEALSO;

    /**
     * Costruttore per l'azione StartGetSeeAlso
     * @param payload {number} id del glossario selezionato
     */
    constructor(public payload: number) { }
}

/**Azione di avvenuto recupero dei see also alla voce di glossario selezionata */
export class GetSeeAlsoSuccess implements Action {
    readonly type = GET_SEEALSO_SUCCESS;

    /**
     * Costruttore per l'azione di avvenuto recupero dei see also
     * @param payload {Glossary[]} elenco dei see also relativi alla voce di glossario selezionata
     */
    constructor(public payload: Glossary[]) { }
}

/**Azione di mancato recupero dei see also per la voce di glossario selezionata */
export class GetSeeAlsoFailure implements Action {
    readonly type = GET_SEEALSO_FAILURE;

    constructor(public payload: any) { }
}

/**Azione per l'aggiunta di un array di filtri da applicare alle richieste delle voci di glossario */
export class ApplyFilters implements Action {
    readonly type = APPLY_FILTERS;
    /**
     * Costruttore per l'azione di applicazione di nuovi filtri
     * @param payload {object} sezione {tabellaGlossari} a quale tabella applicare i filtri, elencoFiltri {FiltroGlossario[]} l'array di filtri da applicare
     */
    constructor(public payload: { sezione: tabellaGlossari, elencoFiltri: (SingleFilter | OperatorFilter) }) { }
}

/**Azione per visualizzare o nascondere lo spinner di caricamento tabella glossari principale */
export class IsLoadingTabella implements Action {
    readonly type = IS_LOADING_TABELLA;

    /**
     * Costruttore per l'azione di visualizzazione spinner
     * @param payload {object} sezione (tabellaGlossari) la tabella che richiede lo spinner, valore (boolean) definisce se il caricamento è in corso o meno
     */
    constructor(public payload: { sezione: tabellaGlossari, valore: boolean }) { }
}

/**Azione per impostare un nuovo intervallo di voci glossario da recuperare da BE */
export class SetRowInterval implements Action {
    readonly type = SET_ROW_INTERVAL;

    /**
     * Costruttore per l'azione di impostazione intervallo voci
     * @param payload {object} sezione {tabellaGlossari} su quale elenco di voci stiamo lavorando, fromRow {number} indice iniziale dell'intervallo incluso, toRow {number} indice finale dell'intervallo escluso
     */
    constructor(public payload: { sezione: tabellaGlossari, fromRow: number, toRow: number }) { }
}

/**Azione per la rimozione di tutti i dati legati al modale di ricerca glossari */
export class DestroyModalCercaGlossario implements Action {
    readonly type = DESTROY_MODAL_CERCA_GLOSSARIO;
}

/**Azione per la memorizzazione delle selezioni secondarie sulla tabella glossari principale */
export class SetSecondarySelections implements Action {
    readonly type = SET_SECONDARY_SELECTIONS;

    /**
     * Costruttore per l'azione di memorizzazione selezioni secondarie
     * @param payload {Glossary[]} le selezioni secondarie 
     */
    constructor(public payload: Glossary[]) { }
}

/**Azione di inizio aggiunta nuova voce see also */
export class StartAddSeeAlso implements Action {
    readonly type = START_ADD_SEEALSO;

    /**
     * Costruttore per l'azione di inizio aggiunta nuovo see also
     * @param payload {object} idGlos {number} id del glossario principale, seeAlso {Glossary} see also da aggiungere
     */
    constructor(public payload: { idGlos: number, seeAlso: Glossary }) { }
}

/**Azione di avvenuta aggiunta nuova voce see also */
export class AddSeeAlsoSuccess implements Action {
    readonly type = ADD_SEEALSO_SUCCESS;

    /**
     * Costruttore per l'azione di AddSeeAlsoSuccess
     * @param payload {Glossary} il glossario aggiornato
     */
    constructor(public payload: Glossary) { }
}

/**Azione di mancata aggiunta nuova voce see also */
export class AddSeeAlsoFailure implements Action {
    readonly type = ADD_SEEALSO_FAILURE;
}

/**Azione di inizio rimozione voce see also */
export class StartRemoveSeeAlso implements Action {
    readonly type = START_REMOVE_SEEALSO;

    /**
     * Costruttore per l'azione di inizio rimozione see also
     * @param payload {object} idGlos {number} id del glossario principale, idSeeAlso {number} id del see also da rimuovere
     */
    constructor(public payload: { idGlos: number, idSeeAlso: number }) { }

}

/**Azione di avvenuta rimozione voce see also */
export class RemoveSeeAlsoSuccess implements Action {
    readonly type = REMOVE_SEEALSO_SUCCESS;

    /**
     * Costruttore per l'azione RemoveSeeAlsoSuccess
     * @param payload {number} identificativo del glossario see also rimosso
     */
    constructor(public payload: number) { }
}

/**Azione di mancata rimozione voce see also */
export class RemoveSeeAlsoFailure implements Action {
    readonly type = REMOVE_SEEALSO_FAILURE;
}

/**Azione di inizio inserimento di un nuovo glossario */
export class StartAddNewGlossary implements Action {
    readonly type = START_ADD_NEW_GLOSSARY;

    /**
     * Costruttore per l'azione di StartAddNewGlossary
     * @param payload {object} newGlos (Glossary) il nuovo glossario da inserire, filtri (FiltroServiziList) i filtri da applicare con i valori del nuovo glossario
     * @param isUndoRedoOperation {boolean} definisce se l'azione è lanciata nell'ambito di un'azione di undo
     */
    constructor(public payload: { newGlos: Glossary, filtri: (SingleFilter | OperatorFilter) },
        public isUndoRedoOperation: boolean = false) { }
}
/**Azione di avvenuto inserimento di un nuovo glossario */
export class AddNewGlossarySuccess implements Action {
    readonly type = ADD_NEW_GLOSSARY_SUCCESS;

    /**
     * Costruttore per l'azione di AddNewGlossarySuccess
     * @param payload {object} newGlos (Glossary) il nuovo glossario inserito, filtri (FiltroServiziList) i filtri da applicare alla tabella con i valori del nuovo glos
     * @param isUndoRedoOperation {boolean} definisce se l'azione è lanciata nell'ambito di un'azione di undo
     */
    constructor(public payload: { newGlos: Glossary, filtri: (SingleFilter | OperatorFilter) },
        public isUndoRedoOperation: boolean = false) { }
}
/**Azione di mancato inserimento di un nuovo glossario */
export class AddNewGlossaryFailure implements Action {
    readonly type = ADD_NEW_GLOSSARY_FAILURE;
}

/**Azione di inizio rimozione di una voce di glossario */
export class StartRemoveGlossary implements Action {
    readonly type = START_REMOVE_GLOSSARY;

    /**
     * Costruttore per l'azione StartRemoveGlossary
     * @param payload {number} identificativo del glossario da rimuovere
     * @param isUndoRedoOperation {boolean} definisce se l'azione è lanciata nell'ambito di un'azione di undo
     */
    constructor(public payload: number,
        public isUndoRedoOperation: boolean = false) { }
}
/**Azione di rimozione glossario avvenuta con successo */
export class RemoveGlossarySuccess implements Action {
    readonly type = REMOVE_GLOSSARY_SUCCESS;

    /**
     * Costruttore per l'azione RemoveGlossarySuccess
     * @param payload {number} identificativo del glossario da rimuovere
     * @param isUndoRedoOperation {boolean} definisce se l'azione è lanciata nell'ambito di un'azione di undo
     */
    constructor(public payload: number,
        public isUndoRedoOperation: boolean = false) { }
}
/**Azione di mancata rimozione di glossario */
export class RemoveGlossaryFailure implements Action {
    readonly type = REMOVE_GLOSSARY_FAILURE;
}

/**Azione di gestione della visualizzazione dell'elemento di aggiunta */
export class ChangeDisplayAdd implements Action {
    readonly type = CHANGE_DISPLAY_ADD;

    /**
     * Costruttore per l'azione ChangeDisplayAdd
     * @param payload {boolean} definisce se deve essere mostrata o meno la sezione di add
     */
    constructor(public payload: boolean) { }
}

/**Azione di inizio ripristino di una voce di glossario */
export class StartRestoreGlos implements Action {
    readonly type = START_RESTORE_GLOS;

    /**
     * Costruttore per l'azione StartRestoreGlos
     * @param payload {number} identificativo della voce di glossario da ripristinare
     */
    constructor(public payload: number) { }
}
/**Azione di ripristino di una voce di glossario avvenuta con successo */
export class RestoreGlosSuccess implements Action {
    readonly type = RESTORE_GLOS_SUCCESS;
}
/**Azione di mancato ripristino di una voce di glossario */
export class RestoreGlosFailure implements Action {
    readonly type = RESTORE_GLOS_FAILURE;
}

/**Azione di inizio aggiornamento della traduzione di un riferimento */
export class StartUpdateReferenceTransl implements Action {
    readonly type = START_UPDATE_REFERENCE_TRANSL;

    /**
     * Costruttore per l'azione StartUpdateReferenceTransl
     * @param payload {object} idRef (number) identificativo del riferimento, newTranslation (string) nuova traduzione
     */
    constructor(public payload: { idRef: number, newTranslation: string }) { }
}
/**Azione di aggiornamento della traduzione di un riferimento avvenuta con successo */
export class UpdateReferenceTranslSuccess implements Action {
    readonly type = UPDATE_REFERENCE_TRANSL_SUCCESS;

    /**
     * Costruttore per l'azione UpdateReferenceTranslSuccess
     * @param payload {Translation} riferimento/traduzione aggiornata
     */
    constructor(public payload: Translation) { }
}
/**Azione di mancato aggiornamento della traduzione di un riferimento */
export class UpdateReferenceTranslFailure implements Action {
    readonly type = UPDATE_REFERENCE_TRANSL_FAILURE;
}

/**Azione di inizio dissociazione di un glossario da riferimento in sezione Glossari */
export class StartDissociateGlosFromGlosSect implements Action {
    readonly type = START_DISSOCIATE_GLOS_FROM_GLOS_SECT;

    /**
     * Costruttore per l'azione StartDissociateGlosFromGlosSect
     * @param payload {object} translationId (number) identificativo della traduzione/riferimento da cui dissociare il glossario, glossaryId (number) identificativo del glossario, referenceNumber (number) numero totale dei riferimenti
     */
    constructor(public payload: { translationId: number, glossaryId: number, referenceNumber: number },
        public isIncomeSeeAlsoTransl: boolean = false) { }
}
/**Azione di dissociazione di un glossario da riferimento in sezione Glossari avvenuta con successo */
export class DissociateGlosFromGlosSectSuccess implements Action {
    readonly type = DISSOCIATE_GLOS_FROM_GLOS_SECT_SUCCESS;

    /**
     * Costruttore per l'azione DissociateGlosFromGlosSectSuccess
     * @param payload {object} glossaryId (number) identificativo del glossario dissociato, referenceNumber (number) numero di riferimenti
     */
    constructor(public payload: { glossaryId: number, referenceNumber: number, translationId: number },
        public isIncomeSeeAlsoTransl: boolean = false) { }
}
/**Azione di mancata dissociazione di un glossario da riferimento in sezione Glossari */
export class DissociateGlosFromGlosSectFailure implements Action {
    readonly type = DISSOCIATE_GLOS_FROM_GLOS_SECT_FAILURE;
}

/**Azione di inizio dissociazione di un glossario da tutti i riferimenti */
export class StartDissociateAllReferences implements Action {
    readonly type = START_DISSOCIATE_ALL_REFERENCES;
    /**
     * Costruttore per l'azione StartDissociateAllReferences
     * @param payload {number} identificativo del glossario da dissociare
     */
    constructor(public payload: number) { }
}
/**Azione di dissociazione di un glossario da tutti i riferimenti avvenuta con successo */
export class DissociateAllReferencesSuccess implements Action {
    readonly type = DISSOCIATE_ALL_REFERENCES_SUCCESS;
    /**
     * Costruttore per l'azione DissociateAllReferencesSuccess
     * @param payload {object} dissociationMex (string) messaggio di conferma dissociazione con rapporto dissociati su totale, glossaryId (number) identificativo del glossario dissociato
     */
    constructor(public payload: { dissociationMex: string, glossaryId: number }) { }
}
/**Azione di mancata dissociazione di un glossario da tutti i riferimenti */
export class DissociateAllReferencesFailure implements Action {
    readonly type = DISSOCIATE_ALL_REFERENCES_FAILURE;
}

/**Azione di inizio recupero delle note a un riferimento/traduzione */
export class StartGetReferenceNotes implements Action {
    readonly type = START_GET_REFERENCE_NOTES;
    /**
     * Costruttore per l'azione StartGetReferenceNotes
     * @param payload {number} identificativo del riferimento/traduzione
     */
    constructor(public payload: number) { }
}
/**Azione di recupero delle note a un riferimento/traduzione avvenuta con successo */
export class GetReferenceNotesSuccess implements Action {
    readonly type = GET_REFERENCE_NOTES_SUCCESS;
    /**
     * Costruttore per l'azione GetReferenceNotesSuccess
     * @param payload {Note[]} lista di note associate al riferimento/traduzione
     */
    constructor(public payload: Note[]) { }
}
/**Azione di mancato recupero delle note a un riferimento/traduzione */
export class GetReferenceNotesFailure implements Action {
    readonly type = GET_REFERENCE_NOTES_FAILURE;
}

/**Azione di inizio recupero dei glossari associati un riferimento/traduzione */
export class StartGetReferenceGlossaries implements Action {
    readonly type = START_GET_REFERENCE_GLOSSARIES;
    /**
     * Costruttore per l'azione StartGetReferenceGlossaries
     * @param payload {number} identificativo del riferimento/traduzione
     */
    constructor(public payload: number) { }
}
/**Azione di recupero dei glossari associati a un riferimento/traduzione avvenuta con successo */
export class GetReferenceGlossariesSuccess implements Action {
    readonly type = GET_REFERENCE_GLOSSARIES_SUCCESS;
    /**
     * Costruttore per l'azione GetReferenceGlossariesSuccess
     * @param payload {Glossary[]} lista di glossari associati al riferimento/traduzione
     */
    constructor(public payload: Glossary[]) { }
}
/**Azione di mancato recupero dei glossari associati a un riferimento/traduzione */
export class GetReferenceGlossariesFailure implements Action {
    readonly type = GET_REFERENCE_GLOSSARIES_FAILURE;
}

/**Azione di pulizia dei dettagli a un riferimento/traduzione */
export class CleanReferenceDetails implements Action {
    readonly type = CLEAN_REFERENCE_DETAILS;
}

/**Azione di inizio recupero dello storico di un glossario */
export class StartGetGlosHistory implements Action {
    readonly type = START_GET_GLOS_HISTORY;
    /**
     * Costruttore per l'azione di StartGetGlosHistory
     * @param payload {number} identificativo del glossario
     */
    constructor(public payload: number) { }
}
/**Azione di recupero dello storico di un glossario avvenuta con successo */
export class GetGlosHistorySuccess implements Action {
    readonly type = GET_GLOS_HISTORY_SUCCESS;
    /**
     * Costruttore per l'azione GetGlosHistorySuccess
     * @param payload {Glossary[]} lista delle versioni precedenti del glossario ad eccezione dell'attuale
     */
    constructor(public payload: Glossary[]) { }
}
/**Azione di mancato recupero dello storico di un glossario */
export class GetGlosHistoryFailure implements Action {
    readonly type = GET_GLOS_HISTORY_FAILURE;
}

/**Azione di visualizzazione dello storico glossari */
export class DisplayGlosHistory implements Action {
    readonly type = DISPLAY_GLOS_HISTORY;
    /**
     * Costruttore per l'azione DisplayglosHistory
     * @param payload {boolean} definisce se il modale dello storico debba essere visualizzato o meno
     */
    constructor(public payload: boolean) { }
}

/**Azione di inizio convergenza dei riferimenti di più glossari su un unico glossario */
export class StartAssociateMultipleGlos implements Action {
    readonly type = START_ASSOCIATE_MULTIPLE_GLOS;
    /**
     * Costruttore per l'azione StartAssociateMultipleGlos
     * @param payload {object} target (number) identificativo del glossario target, source (number[]) elenco degli identificativi dei glossari sorgente cui sono associati i riferimenti
     */
    constructor(public payload: { target: number, source: number[] }) { }
}
/**Azione di convergenza dei riferimenti di più glossari su un unico glossario avvenuta con successo */
export class AssociateMultipleGlosSuccess implements Action {
    readonly type = ASSOCIATE_MULTIPLE_GLOS_SUCCESS;
    /**
     * Costruttore per l'azione AssociateMultipleGlosSuccess
     * @param payload {object} glosId (number) identificativo del glossario target, responseMex (string) messaggio di avvenuta convergenza con rapporto riferimenti spostati su riferimenti totali
     */
    constructor(public payload: { glosId: number, responseMex: string }) { }
}
/**Azione di mancata convergenza dei riferimenti di più glossari su un unico glossario */
export class AssociateMultipleGlosFailure implements Action {
    readonly type = ASSOCIATE_MULTIPLE_GLOS_FAILURE;
}

/**Azione di inizio recupero riferimenti/traduzioni in cui sono taggati glossari che puntano al glossario selezionato come vedi anche */
export class StartGetSeeAlsoIncomeTranslations implements Action {
    readonly type = START_GET_SEEALSO_INCOME_TRANSLATIONS;
    /**
     * Costruttore per l'azione StartGetSeeAlsoIncomeTranslations
     * @param payload {number} identificativo del glossario che punta come vedi anche
     */
    constructor(public payload: number) { }
}
/**Azione di recupero riferimenti/traduzioni in cui sono taggati glossari che puntano al glossario selezionato come vedi anche avvenuto con successo */
export class GetSeeAlsoIncomeTranslationsSuccess implements Action {
    readonly type = GET_SEEALSO_INCOME_TRANSLATIONS_SUCCESS;
    /**
     * Costruttore per l'azione GetSeeAlsoIncomeTranslationsSuccess
     * @param payload {Translation[]} lista di riferimenti/traduzioni recuperate
     */
    constructor(public payload: Translation[]) { }
}
/**Azione di mancato recupero riferimenti/traduzioni in cui sono taggati glossari che puntano al glossario selezionato come vedi anche */
export class GetSeeAlsoIncomeTranslationsFailure implements Action {
    readonly type = GET_SEEALSO_INCOME_TRANSLATIONS_FAILURE;
}

/**Azione di inizio recupero dei glossari che puntano al glossario selezionato come vedi anche */
export class StartGetSeeAlsoIncome implements Action {
    readonly type = START_GET_SEEALSO_INCOME;
    /**
     * Costruttore per l'azione StartGetSeeAlsoIncome
     * @param payload {number} identificativo del glossario selezionato
     */
    constructor(public payload: number) { }
}
/**Azione di recupero dei glossari che puntano al glossario selezionato come vedi anche avvenuto con successo */
export class GetSeeAlsoIncomeSuccess implements Action {
    readonly type = GET_SEEALSO_INCOME_SUCCESS;

    /**
     * Costruttore per l'azione GetSeeAlsoIncomeSuccess
     * @param payload {object} indexArray (object) id (number) identificativo del glossario see also income name (string) voce del glossario see also income, observableList (Observable<Translation[]>[]) elenco degli observable per chiamate multiple consecutive per il recupero delle traduzioni
     */
    constructor(public payload: { indexArray: { id: number, name: string }[], observableList: Observable<Translation[]>[] }) { }
}
/**Azione di mancato recupero dei glossari che puntano al glossario selezionato come vedi anche */
export class GetSeeAlsoIncomeFailure implements Action {
    readonly type = GET_SEEALSO_INCOME_FAILURE;
}

/**Azione di inizio recupero allegato a un glossario */
export class StartGetGlossaryAttachment implements Action {
    readonly type = START_GET_GLOSSARY_ATTACHMENT;

    /**
     * Costruttore per l'azione StartGetGlossaryAttachment
     * @param payload {number} identificativo del glossario
     */
    constructor(public payload: number) { }
}
/**Azione di avvenuto recupero allegato a un glossario */
export class GetGlossaryAttachmentSuccess implements Action {
    readonly type = GET_GLOSSARY_ATTACHMENT_SUCCESS;

    /**
     * Costruttore per l'azione GetGlossaryAttachmentSuccess
     * @param payload {Attachment} allegato del glossario
     */
    constructor(public payload: Attachment) { }
}
/**Azione di mancato recupero allegato a un glossario */
export class GetGlossaryAttachmentFailure implements Action {
    readonly type = GET_GLOSSARY_ATTACHMENT_FAILURE;
}

/**Tipi di azioni disponibili per la sezione glossari dello stato */
export type GlossariAction =
    | StartGetListGlos
    | GetListGlosSuccess
    | GetListGlosFailure
    | CleanOnDestroy
    | ApplySortGlos
    | SelectGlossary
    | StartUpdateGlossary
    | UpdateGlossarySuccess
    | UpdateGlossaryFailure
    | StartUpdateMultipleFields
    | UpdateMultipleFieldsSuccess
    | UpdateMultipleFieldsFailure
    | StartGetTranslations
    | GetTranslationsSuccess
    | GetTranslationsFailure
    | StartGetSeeAlso
    | GetSeeAlsoSuccess
    | GetSeeAlsoFailure
    | ApplyFilters
    | IsLoadingTabella
    | SetRowInterval
    | DestroyModalCercaGlossario
    | SetSecondarySelections
    | StartAddSeeAlso
    | AddSeeAlsoSuccess
    | AddSeeAlsoFailure
    | StartRemoveSeeAlso
    | RemoveSeeAlsoSuccess
    | RemoveSeeAlsoFailure
    | StartAddNewGlossary
    | AddNewGlossarySuccess
    | AddNewGlossaryFailure
    | ChangeDisplayAdd
    | StartRemoveGlossary
    | RemoveGlossarySuccess
    | RemoveGlossaryFailure
    | StartRestoreGlos
    | RestoreUserSuccess
    | RestoreUserFailure
    | StartUpdateReferenceTransl
    | UpdateReferenceTranslSuccess
    | UpdateReferenceTranslFailure
    | StartDissociateGlosFromGlosSect
    | DissociateGlosFromGlosSectSuccess
    | DissociateGlosFromGlosSectFailure
    | StartDissociateAllReferences
    | DissociateAllReferencesSuccess
    | DissociateAllReferencesFailure
    | StartGetReferenceNotes
    | GetReferenceNotesSuccess
    | GetReferenceNotesFailure
    | StartGetReferenceGlossaries
    | GetReferenceGlossariesSuccess
    | GetReferenceGlossariesFailure
    | CleanReferenceDetails
    | StartGetGlosHistory
    | GetGlosHistorySuccess
    | GetGlosHistoryFailure
    | DisplayGlosHistory
    | StartAssociateMultipleGlos
    | AssociateMultipleGlosSuccess
    | AssociateMultipleGlosFailure
    | StartGetSeeAlsoIncomeTranslations
    | GetSeeAlsoIncomeTranslationsSuccess
    | GetSeeAlsoIncomeTranslationsFailure
    | StartGetSeeAlsoIncome
    | GetSeeAlsoIncomeSuccess
    | GetSeeAlsoIncomeFailure
    | StartGetGlossaryAttachment
    | GetGlossaryAttachmentSuccess
    | GetGlossaryAttachmentFailure;